import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Flex, Typography } from '@iheartjane/reefer';
import type { TimeZone } from '@iheartjane/types';

import { GovernmentAssistanceIdentification } from '@jane/monolith/components/identification/governmentAssistanceIdentification';
import { IDIdentification } from '@jane/monolith/components/identification/idIdentification';
import { MedicalIdNumberIdentification } from '@jane/monolith/components/identification/medicalIdNumberIdentification';
import { MMJIdentification } from '@jane/monolith/components/identification/mmjIdentification';
import { PediatricIdentification } from '@jane/monolith/components/identification/pediatricIdentification';
import { SeniorIdentification } from '@jane/monolith/components/identification/seniorIdentification';
import { StudentIdentification } from '@jane/monolith/components/identification/studentIdentification';
import { VeteranIdentification } from '@jane/monolith/components/identification/veteranIdentification';
/* eslint-disable-next-line no-restricted-imports */
import type { Store, StoreSpecial } from '@jane/shared/models';

const renderUploader = ({
  groupType,
  timezone,
  requiredAge,
  store,
  verificationType,
}: {
  groupType: string;
  requiredAge?: number | null;
  store: Store | undefined;
  timezone: TimeZone;
  verificationType?: string | null;
}) => {
  const { medical, state } = store ?? {};

  if (groupType === 'medical') {
    if (state === 'Ohio' && medical) return null;

    return verificationType === 'number' ? (
      <MedicalIdNumberIdentification />
    ) : (
      <MMJIdentification />
    );
  }

  return groupType === 'student' ? (
    <StudentIdentification />
  ) : groupType === 'senior' ? (
    <SeniorIdentification requiredAge={requiredAge || 1} timezone={timezone} />
  ) : groupType === 'veteran' ? (
    <VeteranIdentification />
  ) : groupType === 'pediatric' ? (
    <PediatricIdentification
      requiredAge={requiredAge || 1}
      timezone={timezone}
    />
  ) : groupType === 'ssi' ? (
    <IDIdentification />
  ) : groupType === 'snap' ? (
    <IDIdentification />
  ) : groupType === 'medicare' ? (
    <IDIdentification />
  ) : groupType === 'pace' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'pacenet' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'chip' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'wic' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'PA Gov' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'medicaid' ? (
    <IDIdentification />
  ) : groupType === 'locals' ? (
    <IDIdentification />
  ) : groupType === 'industry' ? (
    <IDIdentification />
  ) : null;
};

export const GroupDiscountDetails = ({
  special,
  timezone,
  store,
}: {
  special?: StoreSpecial;
  store?: Store;
  timezone: TimeZone;
}) => {
  const medIdEnabled = useFlag(FLAGS.c3QualifiedGroupMedId);

  if (!special || special.special_type !== 'qualified_group') return null;
  const groupRules = special.rules?.base;
  if (!groupRules?.type) return null;

  return (
    <Flex
      flexDirection="column"
      width="100%"
      pb={24}
      style={{ containerType: 'inline-size' }}
    >
      {special.terms && (
        <Typography color="text-light" mb={24}>
          {special.terms}
        </Typography>
      )}

      {renderUploader({
        groupType: groupRules.type,
        timezone,
        requiredAge: groupRules.required_age ?? null,
        verificationType: medIdEnabled
          ? groupRules.verification_type || 'photo'
          : 'photo',
        store,
      })}
    </Flex>
  );
};
